
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface SessionNotFoundProps {
  sessionId: string | undefined;
}

const SessionNotFound: React.FC<SessionNotFoundProps> = ({ sessionId }) => {
  const navigate = useNavigate();
  
  return (
    <div className="container mx-auto py-8 text-center">
      <h1 className="text-2xl font-bold mb-4">Session Not Found</h1>
      <p className="mb-4">The session you're looking for with ID {sessionId} doesn't exist or has been removed.</p>
      <Button onClick={() => navigate('/collaboration')}>
        Return to Collaboration
      </Button>
    </div>
  );
};

export default SessionNotFound;
